import { AxiosInstance } from '../../../utilities/requestClient';
import type { RSFundPageModel } from '../../api.types';

export interface GetAssetClassReportDataParams<T> {
  fundId: string;
  reportKey: string;
  positionDate?: string;
  parseResponse: (raw: unknown) => RSFundPageModel<T> | null;
}

export async function getAssetClassReportData<T>({
  fundId,
  reportKey,
  positionDate,
  parseResponse,
}: GetAssetClassReportDataParams<T>): Promise<RSFundPageModel<T> | null> {
  const base = positionDate
    ? 'stored_asset_class_report'
    : 'most_recently_stored_asset_class_report';
  const url = positionDate
    ? `${base}/${fundId}/${reportKey}/${positionDate}`
    : `${base}/${fundId}/${reportKey}`;

  const { data } = await AxiosInstance.get<unknown>(url);
  return parseResponse(data);
}
